// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2R1Cq","modalFooterButton":"ModalNotes_modalFooterButton__3cZ2H"};